function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 24,
  r: 24,
  fill: "#EBEBFB"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5 14a9.922 9.922 0 013.125.5.626.626 0 01-.391 1.189A8.714 8.714 0 0015.792 24a8.711 8.711 0 1017.02-2.625.625.625 0 111.19-.375A10.013 10.013 0 0124.5 34c-5.523 0-10-4.477-10-10s4.477-10 10-10zm0 3.906c.642 0 1.281.102 1.891.303a.625.625 0 11-.388 1.189 4.846 4.846 0 103.105 3.17.625.625 0 111.19-.374 6.066 6.066 0 11-5.798-4.288zm7.172-3.874a.625.625 0 00-.622.148l-2.526 2.492-.054.06a.625.625 0 00-.125.293l-.399 2.634-2.834 2.904a1.556 1.556 0 10.939 1.441v-.125a1.575 1.575 0 00-.085-.402l2.76-2.827 2.803-.426a.611.611 0 00.351-.18l2.482-2.537.055-.066a.625.625 0 00-.382-.987l-1.625-.313-.311-1.632a.625.625 0 00-.427-.477z",
  fill: "#776BE6"
});

function SvgTargetingTrigger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgTargetingTrigger;